import React from "react"
import Layout from "../components/layout"
import { Fade } from "react-awesome-reveal"

import "../styles/pages.scss"
import Seo from "../components/seo"

export default function Disclaimer() {
  return (
    <Layout page="disclaimer">
      <Seo title="Disclaimer" />
      <section>
        <h1>Disclaimer</h1>
        <p>
          Jika kamu memerlukan informasi lebih lanjut atau memiliki pertanyaan
          tentang sanggahan (<i>disclaimer</i>) dari Lensa Opini, silahkan
          hubungi kami melalui alamat email lensapini@gmail.com.
        </p>
      </section>

      <section>
        <h2>Sanggahan dari Lensa Opini</h2>

        <p>
          Semua informasi di situs web ini - lensaopini.com - dipublikasikan
          dengan itikad baik dan hanya untuk tujuan informasi umum. Lensa Opini
          tidak memberikan jaminan apa pun tentang kelengkapan, keandalan, dan
          keakuratan informasi ini. Setiap tindakan yang kamu lakukan atas
          informasi yang kamu temukan di situs web ini (Lensa Opini), sepenuhnya
          merupakan risiko kamu sendiri. Lensa Opini tidak akan bertanggung
          jawab atas kerugian dan/atau kerusakan sehubungan dengan penggunaan
          situs web kami.
        </p>
        <br />
        <p>
          Kamu dapat mengunjungi situs web lain melalui tautan yang tersedia di
          dalam situs kami. Meskipun kami selalu berusaha untuk hanya menyajikan
          tautan yang bermanfaat dan etis, kami tidak memiliki kendali atas
          konten maupun ketentuan yang ada di situs-situs lain. Pemilik dan
          konten situs ini dapat berubah tanpa adanya pemberitahuan terlebih
          dahulu dan hal ini dapat terjadi bahkan sebelum kami memiliki
          kesempatan untuk menghapus tautan-tautan yang tidak layak.
        </p>
        <br />
        <p>
          Perlu diketahui juga bahwa ketika kamu meninggalkan situs web kami,
          situs lain mungkin memiliki kebijakan dan ketentuan privasi berbeda
          yang berada di luar kendali kami. Harap pastikan untuk memeriksa
          Kebijakan Privasi situs-situs tersebut serta Persyaratan Layanan
          mereka sebelum terlibat dalam bisnis atau mengunggah apa pun.
        </p>
      </section>
      <Fade bottom>
        <section>
          <h2>Persetujuan</h2>
          <p>
            Dengan menggunakan situs web kami, Anda dengan ini menyetujui
            penyangkalan kami dan menyetujui persyaratannya.
          </p>
        </section>

        <section>
          <h2>Pembaruan</h2>
          <p>
            Jika kami memperbarui, mengubah atau membuat perubahan apa pun pada
            dokumen ini, perubahan tersebut akan diposting secara jelas di sini.
          </p>
        </section>
      </Fade>
    </Layout>
  )
}
